<template>
  <div>
    <!-- Cabecera -->
    <pm-header>
      <template slot="contenido">
        <div class="row h-100 d-flex align-items-center fondo-header m-0">
          <div
            class="col-12 col-sm-10 offset-sm-1 col-lg-4 offset-lg-1 col-xl-5 offset-xl-2 text-center text-lg-left text-white"
            data-aos="fade-right"
            data-aos-delay="750"
          >
            <p class="fuente-header-titulo p-0 m-0">
              ¡Únete a nuestro equipo de trabajo!
            </p>
          </div>
          <div
            class="col-lg-3 d-none d-lg-block"
            data-aos="fade-left"
            data-aos-delay="500"
          >
            <img class="img-fluid" src="@/assets/img-pub/ContactoLG.png" />
          </div>
        </div>
      </template>
    </pm-header>

    <!-- Cuerpo -->
    <div class="contenedor">
      <div class="row m-4 cuerpo-bolsa-trabajo">
        <div class="col-12 col-md-6 d-flex align-items-center">
          <img class="w-100" src="@/assets/img-pub/bolsa-trabajo.png" />
        </div>

        <div class="col-12 col-md-6 d-flex align-items-center">
          <div class="vr ruler h-50 mr-4 d-none d-md-block"></div>
          <div>
            <p class="fuenteEtiquetaRegular">
              Comparte nuestra pasión por servir a la salud de quienes nos
              rodean, estamos sumando al mejor talento a nuestras áreas.
            </p>
            <div class="d-md-flex justify-content-around align-items-center">
              <button
                type="button"
                class="btn btn-bloque btn-block mx-2"
                @click="$bvModal.show('modal-cv')"
              >
                Env&iacute;a tu
                <br />
                curriculum
              </button>

              <button
                type="button"
                class="btn btn-bloque btn-block mx-2"
                @click="$bvModal.show('modal-solicitud')"
              >
                Llena la Solicitud
                <br />
                en l&iacute;nea
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pie pagina -->
    <pm-pie-pagina></pm-pie-pagina>

    <pm-modal-contacto
      :visible="mostrarModal"
      @close="mostrarModal = false"
    ></pm-modal-contacto>

    <!-- MODAL ENVIA TU CV -->
    <b-modal
      ref="modalCurriculumRef"
      id="modal-cv"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg"
      title="Enviar Curriculum Vitae (CV)"
      @shown="modalFocusNombreCurriculum"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-card bg-variant="light">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="lblNombre">Nombre</label>
              <input
                :class="{
                  'is-invalid': $v.curriculumModel.nombreCurriculum.$error,
                }"
                type="text"
                class="form-control form-control-sm"
                ref="txtNombreCurriculum"
                v-model="$v.curriculumModel.nombreCurriculum.$model"
                placeholder="Ej. José Manuel Sánchez Sauceda"
              />
              <div
                v-if="!$v.curriculumModel.nombreCurriculum.required"
                class="invalid-feedback"
              >
                Informacion requerida.
              </div>
            </div>

            <div class="form-group">
              <label for="lblCorreo">Correo</label>
              <input
                type="email"
                :class="{ 'is-invalid': $v.curriculumModel.email.$error }"
                class="form-control form-control-sm"
                ref="txtCorreoCurriculum"
                v-model="$v.curriculumModel.email.$model"
                placeholder="Ej. jose.sanchez@micorreo.com"
              />
              <div
                v-if="!$v.curriculumModel.email.required"
                class="invalid-feedback"
              >
                Informacion requerida.
              </div>
            </div>

            <div class="form-group">
              <label for="lbltelefono">Teléfono</label>
              <the-mask
                      :mask="'(###) ### ####'"
                      :class="{ 'is-invalid': $v.curriculumModel.telefono.$error }"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtTelefonoCurriculum"
                      v-model="$v.curriculumModel.telefono.$model"
                      placeholder="Ej. (667) 234 12 34"
                    />
              <div
                v-if="!$v.curriculumModel.telefono.required"
                class="invalid-feedback"
              >
                Informacion requerida.
              </div>
            </div>

            <div class="form-group">
              <label class="control-label">Adjuntar Archivo:</label>
              <input
                type="file"
                ref="archivoCurriculum"
                class="form-control-file"
                accept=".pdf,.doc,.docx,.jpg"
                :class="[{ 'is-invalid': !archivo }]"
                @change="cargarCurriculum"
              />
              <div v-if="!archivo" class="invalid-feedback">
                * Solo archivos PDF,DOC o JPG
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button
            size="md"
            variant="danger"
            class="mr-2"
            @click="$bvModal.hide('modal-cv')"
          >
            Cerrar
          </b-button>

          <b-button
            size="md"
            variant="primary"
            class="mr-2"
            @click="confirmaGuardarCV"
          >
            Enviar
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- MODAL SoLICITUD EN LINEA -->
    <b-modal
      ref="modalSolicitudRef"
      id="modal-solicitud"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      title="Solicitud en linea"
      @shown="modalFocusNombreSolicitud"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-card class="card">
        <b-tabs v-model="tabIndex">
          <b-tab title="Datos personales">
            <form class="py-4 px-lg-5">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="lblNombre">Nombre</label>
                      <input
                        :class="{'is-invalid':$v.solicitudTrabajo.datosPersonales.nombre.$error}"
                        type="text"
                        class="form-control form-control-sm"
                        ref="txtNombre"
                        id="txtNombre"
                        v-model="$v.solicitudTrabajo.datosPersonales.nombre.$model"
                        placeholder="Ej. José Manuel Sánchez Sauceda"
                      />
                </div>
                <div class="form-group col-md-6">
                  <label for="lblApellidos">Apellidos</label>
                    <input
                      :class="{'is-invalid': $v.solicitudTrabajo.datosPersonales.apellidos.$error}"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtApellidos"
                      v-model="$v.solicitudTrabajo.datosPersonales.apellidos.$model"
                      placeholder="Ej. José Manuel Sánchez Sauceda"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="lblFechaNacimiento">Fecha de Nacimiento:</label>
                    <div class="input-group input-group-sm">
                      <div class="input-group-append">
                        <b-form-datepicker
                          v-model="$v.solicitudTrabajo.datosPersonales.fechaNacimiento.$model"
                          button-only
                          right
                          size="sm"
                          locale="es-MX"
                          hide-header
                          label-help=""
                        ></b-form-datepicker>
                      </div>
                      <b-form-input
                        id="fechaNacimientoInput"
                        v-model="$v.solicitudTrabajo.datosPersonales.fechaNacimiento.$model"
                        type="text"
                        placeholder="15-03-1989"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="lblCorreo">Correo:</label>
                    <input
                      :class="{'is-invalid':$v.solicitudTrabajo.datosPersonales.correo.$error}"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtCorreo"
                      v-model="$v.solicitudTrabajo.datosPersonales.correo.$model"
                      placeholder="Ej. jose.sanchez@micorreo.com"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="lblTelefono">Teléfono:</label>
                    <the-mask
                      :mask="'(###) ### ####'"
                      :class="{'is-invalid': $v.solicitudTrabajo.datosPersonales.telefono.$error }"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtTelefono"
                      v-model=" $v.solicitudTrabajo.datosPersonales.telefono.$model "
                      placeholder="Ej. (667) 234 12 34"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label for="lblCelular">Teléfono Celular:</label>
                    <the-mask
                      :mask="'(###) ### ####'"
                      :class="{ 'is-invalid': $v.solicitudTrabajo.datosPersonales.celular.$error}"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtCelular"
                      v-model="$v.solicitudTrabajo.datosPersonales.celular.$model"
                      placeholder="Ej. (667) 234 12 34"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                   <label for="lblDomicilio">Domicilio:</label>
                    <input
                      :class="{'is-invalid':$v.solicitudTrabajo.datosPersonales.domicilio.$error}"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtDomicilio"
                      v-model="$v.solicitudTrabajo.datosPersonales.domicilio.$model"
                      placeholder="Ej. Calle Plan de agua prieta #345 Col. Santa Fe"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label for="lblMunicipio">Municipio / Delegación:</label>
                    <input
                      :class="{'is-invalid':$v.solicitudTrabajo.datosPersonales.municipio.$error}"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtMunicipio"
                      v-model="$v.solicitudTrabajo.datosPersonales.municipio.$model"
                      placeholder="Ej. Culiacan"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                   <label for="lblEstadoCivil">Estado Civil:</label>
                    <select
                      name="selectEstadoCivil"
                      id="selectEstadoCivil"
                      ref="selectEstadoCivil"
                      class="form-control form-control-sm"
                      v-model="
                        $v.solicitudTrabajo.datosPersonales.estadoCivil.$model
                      "
                      :class="{
                        'is-invalid':
                          $v.solicitudTrabajo.datosPersonales.estadoCivil
                            .$error,
                      }"
                    >
                      <option value="0" disabled >Seleccione un estado civil</option>
                      <option value="1">Soltero</option>
                      <option value="2">Casado</option>
                    </select>
                </div>
                <div class="form-group col-md-6 pt-2">
                  <div>
                      <label for="lblEstudia">¿Estudia actualmente?</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input  class="form-check-input" 
                              type="radio"
                              v-model="$v.solicitudTrabajo.datosPersonales.estudia.$model"
                              ref="checkEstudiaSi"
                              name="rEstudia" 
                              id="checkEstudiaSi" 
                              value="true">
                      <label class="form-check-label" for="checkEstudiaSi">Si</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input  class="form-check-input" 
                              type="radio"
                              v-model="$v.solicitudTrabajo.datosPersonales.estudia.$model"
                              ref="checkEstudiaNo"
                              name="rEstudia"
                              id="checkEstudiaNo"
                              value="false">
                      <label class="form-check-label" for="checkEstudiaNo">No</label>
                    </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                   <label for="lblPuesto">Puesto Solicitado:</label>
                    <input
                      :class="{
                        'is-invalid':
                          $v.solicitudTrabajo.datosPersonales.puestoSolicitado
                            .$error,
                      }"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtPuesto"
                      v-model="
                        $v.solicitudTrabajo.datosPersonales.puestoSolicitado
                          .$model
                      "
                      placeholder="Ej. Vendedor"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label for="lblUltimoGradoEstudios">
                      &Uacute;ltimo grado de estudios:
                    </label>
                    <input
                      :class="{
                        'is-invalid':
                          $v.solicitudTrabajo.datosPersonales
                            .ultimoGradoEstudios.$error,
                      }"
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtUltimoGradoEstudios"
                      v-model="
                        $v.solicitudTrabajo.datosPersonales.ultimoGradoEstudios
                          .$model
                      "
                      placeholder="Ej. Licenciatura"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                   <div>
                     <label for="lblEstudia">¿Experiencia en el puesto?</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input  class="form-check-input" 
                              type="radio"
                              v-model="$v.solicitudTrabajo.datosPersonales.experiencia.$model"
                              ref="checkTrabajaSi"
                              name="rExperiencia" 
                              id="checkTrabajaSi" 
                              value="true">
                      <label class="form-check-label" for="checkTrabajaSi">Si</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input  class="form-check-input" 
                              type="radio"
                              v-model="$v.solicitudTrabajo.datosPersonales.experiencia.$model"
                              ref="checkTrabajaNo"
                              name="rExperiencia"
                              id="checkTrabajaNo"
                              value="false">
                      <label class="form-check-label" for="checkTrabajaNo">No</label>
                    </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Adjuntar Fotografia:</label>
                    <input
                      type="file"
                      ref="fotografiaSolicitud"
                      class="form-control-file"
                      accept=".jpg"
                      :class="[{ 'is-invalid': !fotoSolicitud }]"
                      @change="cargarFotografia"
                    />
                    <div v-if="!fotoSolicitud" class="invalid-feedback">
                      * Solo archivos JPG
                    </div>
                </div>
              </div>
              <div>
                <b-button
                  size="md"
                  variant="primary"
                  class="mr-2"
                  v-bind:class="HabilitaBtn"
                  :disabled="(HabilitaBtn=='disabled')"
                  @click="siguienteTab"
                >
                  Siguiente
                </b-button>
              </div>
            </form>
          </b-tab>

          <b-tab title="Experiencia laboral">
            <h6 class="p-3">{{ tituloExperienciaLaboral }}</h6>
            <div  v-for="(empleo,index) in solicitudTrabajo.experienciaLaboral" 
                  :key=index
                  class="py-4 px-lg-5"
                  v-show="step === index + 1">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Empresa:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      ref="txtEmpresa"
                      placeholder="Ej. PharmaCeutix"
                      v-model="solicitudTrabajo.experienciaLaboral[index].empresa"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label class="fuenteEtiquetaBold">
                      Principales actividades:
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ej. Activaciones de sucursales"
                      v-model="solicitudTrabajo.experienciaLaboral[index].principalesActividades"
                    />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Puesto:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ej. Promotor"
                      v-model="
                        solicitudTrabajo.experienciaLaboral[index].puesto
                      "
                    />
                </div>
                <div class="form-group col-md-6">
                  <label for="lblFechaNacimiento">Fecha de ingreso:</label>
                    <div class="input-group input-group-sm">
                      <div class="input-group-append">
                        <b-form-datepicker
                          v-model="solicitudTrabajo.experienciaLaboral[index].fechaIngreso"
                          button-only
                          right
                          size="sm"
                          locale="es-MX"
                          hide-header
                          label-help=""
                        ></b-form-datepicker>
                      </div>
                      <b-form-input
                        id="fechaIngresoInput"
                        v-model="solicitudTrabajo.experienciaLaboral[index].fechaIngreso"
                        type="text"
                        placeholder="15-03-1989"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>
                      Tel&eacute;fono de la empresa:
                    </label>
                    <the-mask
                      :mask="'(###) ### ####'"
                      class="form-control form-control-sm"
                      v-model="$v.solicitudTrabajo.experienciaLaboral.$each.$iter[index].telefonoEmpresa.$model"
                      v-bind:class="{'is-invalid':$v.solicitudTrabajo.experienciaLaboral.$each.$iter[index].telefonoEmpresa.$error}"
                      placeholder="Ej. (667) 234 12 34"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label class="fuenteEtiquetaBold">Fecha de salida:</label>
                    <div class="input-group input-group-sm">
                      <div class="input-group-append">
                        <b-form-datepicker
                          v-model="solicitudTrabajo.experienciaLaboral[index].fechaSalida"
                          button-only
                          right
                          size="sm"
                          locale="es-MX"
                          hide-header
                          label-help=""
                        ></b-form-datepicker>
                      </div>
                      <b-form-input
                        id="fechaIngresoInput"
                        v-model="solicitudTrabajo.experienciaLaboral[index].fechaSalida"
                        type="text"
                        placeholder="15-03-1989"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="fuenteEtiquetaBold">
                      Nombre del jefe inmediato:
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ej. José Manuel Sánchez Sauceda"
                      v-model="solicitudTrabajo.experienciaLaboral[index].jefeInmediato"
                    />
                </div>
                <div class="form-group col-md-6">
                    <label class="fuenteEtiquetaBold">
                      Motivo de separaci&oacute;n:
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ej. Cierre de empresa"
                      v-model="solicitudTrabajo.experienciaLaboral[index].motivoSeparacion"
                    />
                </div>
              </div>
            </div>
            <div class="row pt-1 ml-1" v-show="step === 1">
                <span class="text-muted">
                  Añadir otra experiencia laboral
                </span>
            </div>
            <div class="py-4">
              <div class="row ml-1">
                <button
                  type="button"
                  class="btn btn-sm mr-2"
                  v-bind:class="{ 'btn-secondary': 1 == step, 'btn-cuadrado-unete': 1 != step }"
                  v-if="1 <= btn"
                  @click="btn1()"
                >
                  &nbsp;1&nbsp;
                </button>
                <button
                  type="button"
                  class="btn btn-sm mr-2"
                  v-bind:class="{ 'btn-secondary': 2 == step, 'btn-cuadrado-unete': 2 != step, }"
                  v-if="2 <= btn"
                  @click="btn2()"
                >
                  &nbsp;2&nbsp;
                </button>
                <button
                  type="button"
                  class="btn btn-sm mr-2"
                  v-bind:class="{ 'btn-secondary': 3 == step, 'btn-cuadrado-unete': 3 != step, }"
                  v-if="3 <= btn"
                  @click="btn3()"
                >
                  &nbsp;3&nbsp;
                </button>
                <button
                  type="button"
                  class="btn btn-cuadrado-unete btn-sm mr-2"
                  v-if="3 != btn"
                  @click="btnMas()"
                >
                  &nbsp;+&nbsp;
                </button>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <template #modal-footer>
        <div class="d-flex justify-content-center">
          <b-button
            size="md"
            variant="danger"
            class="mr-2"
            @click="$bvModal.hide('modal-solicitud')"
          >
            Cerrar
          </b-button>

          <b-button
            size="md"
            variant="primary"
            class="mr-2"
            v-bind:class="HabilitaBtn"
            :disabled="( HabilitaBtn =='disabled')"
            @click="confirmaGuardarSolicitud"
          >
            Guardar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import PmModalContacto from '@/components/publica/ModalContacto'
import PmHeader from '@/components/publica/Header'
import PmPiePagina from '@/components/publica/PiePagina'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import servicio from '@/services/servicio-bolsa-trabajo'
import { es } from 'vuejs-datepicker/dist/locale'
import { TheMask } from 'vue-the-mask'
import moment from 'moment'

export default {
  components: {
    PmHeader,
    PmPiePagina,
    PmModalContacto,
    TheMask,
  },
  data() {
    return {
      mostrarModal: false,
      tabIndex: 0,
      step: 1,
      btn: 1,
      es: es,
      curriculumModel: {
        nombreCurriculum: '',
        email: '',
        telefono: '',
      },
      solicitudTrabajo: {
        datosPersonales: {
          nombre: '',
          apellidos: '',
          fechaNacimiento: '1990-01-01',
          correo: '',
          telefono: '',
          celular: '',
          domicilio: '',
          municipio: '',
          estadoCivil: '0',
          estudia: 0,
          puestoSolicitado: '',
          ultimoGradoEstudios: '',
          experiencia: 0,
          fotografia: [],
        },
        experienciaLaboral: [
          {
            tipo: '1',
            empresa: '',
            puesto: '',
            telefonoEmpresa: '',
            jefeInmediato: '',
            principalesActividades: '',
            fechaIngreso: '1990-01-01',
            fechaSalida: '1990-01-01',
            motivoSeparacion: '',
          },
          {
            tipo: '2',
            empresa: '',
            puesto: '',
            telefonoEmpresa: '',
            jefeInmediato: '',
            principalesActividades: '',
            fechaIngreso: '1990-01-01',
            fechaSalida: '1990-01-01',
            motivoSeparacion: '',
          },
          {
            tipo: '3',
            empresa: '',
            puesto: '',
            telefonoEmpresa: '',
            jefeInmediato: '',
            principalesActividades: '',
            fechaIngreso: '1990-01-01',
            fechaSalida: '1990-01-01',
            motivoSeparacion: '',
          },
        ],
      },
      headerBgVariant: 'primary',
      headerTextVariant: 'light',
      bodyBgVariant: 'light',
      bodyTextVariant: 'dark',
      inputDisabled: false,
      archivo: true,
      fotoSolicitud: true,
      file: undefined,
      fotografiaSolicitud: undefined,
      modalDeCV: 'modal-cv',
      modalDeSolicitud: 'modal-solicitud',
      modalExperienciaLaboral: 'modalExperienciaLaboral',
      tituloExperienciaLaboral: 'Ultimo o actual empleo',
    }
  },
  methods: {

    modalFocusNombreCurriculum() {
      this.$refs.txtNombreCurriculum.focus()
    },
    modalFocusNombreSolicitud() {
      this.$refs.txtNombre.focus()
    },

    cerrarModal(nombreModal) {

      const valoresIniciales = {
        'modal-cv': this.inicializarValoresCurriculum(),
        'modal-solicitud': this.inicializarValoresSolicitud(),
      }

      if (nombreModal === 'modal-cv') {
        this.curriculumModel = valoresIniciales[nombreModal]
      } else {
        this.solicitudTrabajo = valoresIniciales[nombreModal]
      }

      this[nombreModal] = valoresIniciales[nombreModal]

      this.$bvModal.hide(nombreModal)
      
    },
    confirmaGuardarCV() {
      const camposInvalidos = this.$v.curriculumModel.nombreCurriculum.$invalid
      || this.$v.curriculumModel.email.$invalid
      || this.$v.curriculumModel.telefono.$invalid;

      camposInvalidos
        ? this.$swal.fire('Atencion', 'Hay informacion requerida por llenar', 'warning')
        : this.guardarCV();
    },
    confirmaGuardarSolicitud() {

      const datosPersonales = this.$v.solicitudTrabajo.datosPersonales
      const props = Object.keys(datosPersonales)
      const invalidProps = props.filter(prop => datosPersonales[prop].$invalid)
      
      if (invalidProps.length > 0) {
        this.$swal.fire(
          'Atencion',
          'Hay informacion requerida por llenar',
          'warning',
        )
        return
      }

      this.guardarSolicitud()
    },
    cargarCurriculum() {
      this.archivo = true

      const archivosPermitidos = ['application/docx','application/doc','application/pdf','image/jpeg']
      this.file = this.$refs.archivoCurriculum.files[0]
      if (!this.file ||archivosPermitidos.indexOf(this.file.type) == -1) {
        this.archivo = false
        return
      }
    },
    cargarFotografia() {
      this.fotoSolicitud = true

      const archivosPermitidosSolicitud = ['image/jpeg']

      /*this.solicitudTrabajo.datosPersonales.fotografia*/
      this.fotografiaSolicitud = this.$refs.fotografiaSolicitud.files[0]

      if (
        !this.fotografiaSolicitud ||
        archivosPermitidosSolicitud.indexOf(
          this.$refs.fotografiaSolicitud.files[0].type,
        ) == -1
      ) {
        this.archivo = false
        return
      }
    },
    async guardarCV() {
      try {
        this.$loading(true)
        let formData = new FormData()
        formData.append('files[0]', this.file)
        formData.append('json', JSON.stringify(this.curriculumModel))

        if (this.file.size <= 10 * 1024 * 1024) {

          let r = await servicio.guardarCV(formData)

          if (r.value) {
            this.$loading(false)
            this.cerrarModal(this.modalDeCV)
            this.$swal.fire({
              text: r.message,
              icon: 'success',
            })
          } else {
            this.$loading(false)
            this.cerrarModal(this.modalDeCV)
            this.$swal.fire({
              text: r.message,
              icon: 'warning',
            })
          }
        } else {
          this.$loading(false)
          this.$swal.fire({
            text: 'Los archivos seleccionados no deben de pesar mas de 10MB',
            icon: 'warning',
          })
        }
      } catch (error) {
        this.$loading(false)
        this.file = undefined
        console.log(error)
      }
    },
    async guardarSolicitud() {
      try {
        this.$loading(true)

        this.solicitudTrabajo.datosPersonales.fechaNacimiento = moment(this.solicitudTrabajo.datosPersonales.fechaNacimiento, 'YYYY-MM-DD').toDate();
        
        this.solicitudTrabajo.experienciaLaboral.forEach((experiencia) => {
          experiencia.fechaIngreso = moment(experiencia.fechaIngreso, 'YYYY-MM-DD').toDate();
          experiencia.fechaSalida = moment(experiencia.fechaSalida, 'YYYY-MM-DD').toDate();
        });



        let formData = new FormData()
        formData.append('files[0]', this.fotografiaSolicitud)
        formData.append('json', JSON.stringify(this.solicitudTrabajo))

        //if (this.fotografiaSolicitud.size <= 10 * 1024 * 1024) {
          this.solicitudTrabajo.datosPersonales.fotografia = this.fotografiaSolicitud

          let r = await servicio.guardarSolicitud(formData)
          if (r.value) {
            this.$loading(false)
            this.cerrarModal(this.modalDeSolicitud)
            this.$swal.fire({
              text: r.message,
              icon: 'success',
            })
          } else {
            this.$loading(false)
            this.cerrarModal(this.modalDeSolicitud)
            this.$swal.fire({
              text: r.message,
              icon: 'warning',
            })
          }

      } catch (error) {
        this.$loading(false)
        this.file = undefined
        console.log(error)
      }
    },
    btn1() {
      this.step = 1
      this.tituloExperienciaLaboral = 'Ultimo o actual empleo'
    },
    btn2() {
      this.step = 2
      this.tituloExperienciaLaboral = 'Penúltimo empleo'
    },
    btn3() {
      this.step = 3
      this.tituloExperienciaLaboral = 'Antepenúltimo empleo'
    },
    btnMas() {
      this.step += 1
      this.btn = this.step

      switch (this.step) {
        case 1:
          this.tituloExperienciaLaboral = 'Ultimo o actual empleo'
          break
        case 2:
          this.tituloExperienciaLaboral = 'Penúltimo empleo'
          break
        case 3:
          this.tituloExperienciaLaboral = 'Antepenúltimo empleo'
          break

        default:
          break
      }
    },
    siguienteTab() {
      this.tabIndex++
      this.$nextTick(function () {
        if (this.$refs.txtEmpresa && typeof this.$refs.txtEmpresa.focus === 'function') {
          this.$refs.txtEmpresa.focus();
        }
      })
    },
    inicializarValoresCurriculum() {
      return {
          nombreCurriculum: '',
          email: '',
          telefono: '',
          file: undefined,
        }
    },
    inicializarValoresSolicitud() {
      
      const defaultValues = {
        nombre: '',
        apellidos: '',
        fechaNacimiento: '1990-01-01',
        correo: '',
        telefono: '',
        celular: '',
        domicilio: '',
        municipio: '',
        estadoCivil: '0',
        estudia: 0,
        puestoSolicitado: '',
        ultimoGradoEstudios: '',
        experiencia: 0,
        foto: undefined
      };

      const solicitudTrabajo = {
        datosPersonales: { ...defaultValues },
        experienciaLaboral: [
          { tipo: '1', empresa: '', puesto: '', telefonoEmpresa: '', jefeInmediato: '', principalesActividades: '', fechaIngreso: '1990-01-01', fechaSalida: '1990-01-01', motivoSeparacion: '' },
          { tipo: '2', empresa: '', puesto: '', telefonoEmpresa: '', jefeInmediato: '', principalesActividades: '', fechaIngreso: '1990-01-01', fechaSalida: '1990-01-01', motivoSeparacion: '' },
          { tipo: '3', empresa: '', puesto: '', telefonoEmpresa: '', jefeInmediato: '', principalesActividades: '', fechaIngreso: '1990-01-01', fechaSalida: '1990-01-01', motivoSeparacion: '' }
        ]
      };

      return solicitudTrabajo;

    },
    formatPhone: function(value) {
        // Eliminar caracteres no numéricos
        let phoneNumber = value.replace(/\D/g, '');

        // Dividir el número en grupos de tres dígitos
        let formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

        return formattedPhoneNumber;
    },
  },
  validations: {
    curriculumModel: {
      nombreCurriculum: { required },
      email: { required },
      telefono: { required, minLength: minLength(10) },
    },
    solicitudTrabajo: {
      datosPersonales: {
        nombre: { required },
        apellidos: { required },
        fechaNacimiento: { required },
        correo: { required },
        telefono: { required, minLength: minLength(10) },
        celular: { required, minLength: minLength(10) },
        domicilio: { required },
        municipio: { required },
        estadoCivil: { required },
        estudia: { required },
        puestoSolicitado: { required },
        ultimoGradoEstudios: { required },
        experiencia: { required },
      },
      experienciaLaboral: {
        $each: {
          telefonoEmpresa: {
            required,
            minLength: minLength(10),
            maxLength: maxLength(10),
          },
        },
      },
    },
  },
  computed: {
    HabilitaBtn() {
      const dp = this.solicitudTrabajo.datosPersonales
      const values = dp ? Object.values(dp) : []
      return values.every(value => value !== '') ? '' : 'disabled'
    },

  },
}
</script>

<style scoped>
.fondo-header {
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;
}
.fuente-header-titulo {
  font-weight: 600;
  color: white;
}
.fuente-header-subtitulo {
  color: white;
}
.fuenteEtiquetaRegular {
  color: #335198;
  font-size: 25px;
}
/* .borderVertical {
  border-right: none;
} */
.btn-block+.btn-block {
    margin-top: 0rem;
}

.fuente-cuerpo-titulo {
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  font-style: italic;
  color: #f1c240;
}
.btn-cuadrado-unete {
  background-color: #e9e9e9;
  color: #969798;
}
.btn-bloque {
  background-color: #335198;
  color: #e9e9e9;
  height: 5em;
}
.ruler {
  border-left: 2px solid #f1c240 !important;
  height: 100%;
}

.cuerpo-bolsa-trabajo {
  height: 100%;
}
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.contenedor {
  height: 100vh;
}

/* xs */
/* Estos estilos solo se aplicaran hasta el tamaño indicado */
@media screen and (max-width: 575px) {
  .fondo-header {
    background-image: url('../../assets/img-pub/ContactoXS.png');
  }
  .fuente-header-titulo {
    font-size: 30px !important;
  }
  .fuente-header-subtitulo {
    font-size: 28px !important;
  }
  .fuente-sucursal-nombre {
    font-size: 18px !important;
    font-family: 'Open Sans' !important;
    color: #335198;
    font-weight: bold;
  }
  .fuente-sucursal-direccion {
    font-size: 10px !important;
    font-family: 'Open Sans' !important;
    font-weight: normal;
  }
  .fuente-cuerpo-titulo {
    font-size: 20px !important;
  }
  .btn-bloque {
    margin-bottom: 3px;
  }
}

/* sm */
/* Estos estilos solo se aplicaran hasta el tamaño indicado */
@media screen and (min-width: 576px) and (max-width: 767px) {
  .fondo-header {
    background-image: url('../../assets/img-pub/ContactoXS.png');
  }
  .fuente-header-titulo {
    font-size: 43px !important;
  }
  .fuente-header-subtitulo {
    font-size: 43px !important;
  }
  .fuente-sucursal-nombre {
    font-size: 18px !important;
    font-family: 'Open Sans' !important;
    color: #335198;
    font-weight: bold;
  }
  .fuente-sucursal-direccion {
    font-size: 10px !important;
    font-family: 'Open Sans' !important;
    font-weight: normal;
  }
  .fuente-cuerpo-titulo {
    font-size: 20px !important;
  }
  .btn-bloque {
    margin-bottom: 3px;
  }
}

/* md */
/* Solo se aplicaran entre los tamaños indicados */
@media screen and (min-width: 768px) and (max-width: 991px) {
  .fondo-header {
    background-image: url('../../assets/img-pub/ContactoXS.png');
  }
  .fuente-header-titulo {
    font-size: 43px !important;
  }
  .fuente-header-subtitulo {
    font-size: 43px !important;
  }
  .fuente-cuerpo-titulo {
    font-size: 20px !important;
  }
}

/* lg */
/* Solo se aplicaran entre los tamaños indicados */
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .fuente-header-titulo {
    font-size: 43px !important;
  }
  .fuente-header-subtitulo {
    font-size: 43px !important;
  }
  .fuente-cuerpo-titulo {
    font-size: 28px !important;
  }
}

/* xl */
/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
@media screen and (min-width: 1200px) {
  .fuente-header-titulo {
    font-size: 55px !important;
  }
  .fuente-header-subtitulo {
    font-size: 50px !important;
  }
  .fuente-cuerpo-titulo {
    font-size: 32px !important;
  }
}
</style>
